import waitingFallbackIcon from "../../assets/waitingFallbackIcon.svg";

export default function FeatureFlagsFallback(props) {
  return (
    <div
      className={`inherit-parent-height flex-direction-column flex-justify-content-center flex-align-items-center font-size-large font-weight-normal font-family-gilroy-medium text-align-center padding-larger `}
      data-cy={props.dataCy || "FEATURE-FLAG-FALLBACK"}
    >
      <img src={waitingFallbackIcon} alt="waiting fallback icon" />
      <div className="padding-top-large">Under maintenance</div>

      <div className=" font-family-gilroy-regular padding-top-medium ">
        Thanks for being patient. Our team is working on this feature, please
        check back after sometime.
      </div>
    </div>
  );
}
